<form class="cerca_grey">
	<div searchTextInput #searchElement [url]="requestUrl" [isAmministrazioneModule]="isAmministrazioneModule"
		(onReturn)="refresh($event)"></div>
</form>
<ul id="controparticollapse" class="controparti">
	<li class="panel" *ngFor="let option of optionsList; let indice = index">
		<div class="controparte">
			<div *ngIf="isAmministrazioneModule" class="data_opzioni" appDropdownFocus>
				<ul>
					<li class="opzioni"><a class="dropdown-toggle" data-toggle="dropdown" href="#" role="button"
							aria-haspopup="true" aria-expanded="false">Opzioni<span
								class="glyphicon glyphicon-option-vertical"></span></a>
						<div class="dropdown-menu">
							<ul>
								<li *ngIf="option.anagrafica.rimosso == false"><a href="javascript:void(0)"
										(click)="disableParte(option.anagrafica, indice)"> <span
											class="glyphicon glyphicon-off"></span>Disattiva
									</a></li>
								<li *ngIf="option.anagrafica.rimosso == true"><a href="javascript:void(0)"
										(click)="enableParte(option.anagrafica, indice)"> <span
											class="glyphicon glyphicon-off"></span>Attiva
									</a></li>
							</ul>
						</div>
					</li>
				</ul>
			</div>
			<div>
				<a data-toggle="collapse" href="#subcontroparteModalAdd{{indice}}" aria-expanded="false"
					(click)="prendiDettagliAnagrafica(option, indice)" aria-label="Apri dettaglio"
					[attr.aria-controls]="'subcontroparteModalAdd' + indice" data-parent="#controparticollapse"
					class="collapsed"><span class="sr-only">Apri dettaglio controparte</span></a>
				<p *ngIf="!isAmministrazioneModule" class="col-sm-2">
					<button class="btn btn-primary associa" (click)="associa(option, indice)">{{labelButton}}</button>
				</p>
				<h4 class="titolo col-xs-8 col-sm-3"
					*ngIf="option.anagrafica.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
					<a data-toggle="collapse" href="#subcontroparteModalAdd{{indice}}"
						(click)="prendiDettagliAnagrafica(option, indice)" aria-expanded="false"
						[attr.aria-controls]="'subcontroparteModalAdd' + indice"
						data-parent="#controparticollapse">{{option.anagrafica.cognome}}
						{{option.anagrafica.nome}}</a>
				</h4>
				<h4 class="titolo col-xs-8 col-sm-4"
					*ngIf="option.anagrafica.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
					<a data-toggle="collapse" href="#subcontroparteModalAdd{{indice}}"
						(click)="prendiDettagliAnagrafica(option, indice)" aria-expanded="false"
						[attr.aria-controls]="'subcontroparteModalAdd' + indice"
						data-parent="#controparticollapse">{{option.anagrafica.ragioneSociale}}</a>
				</h4>
				<p class="col-xs-3 col-sm-3 matricola hidden-xs"
					*ngIf="option.anagrafica.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA">
					C/F: <strong>{{option.anagrafica.codiceFiscale}}</strong>
				</p>
				<p class="col-xs-3 col-sm-3 matricola hidden-xs"
					*ngIf="option.anagrafica.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_GIURIDICA">
					P.IVA: <strong>{{option.anagrafica.partitaIva}}</strong>
				</p>
				<p class="col-xs-1 col-sm-1 matricola" *ngIf="isAmministrazioneModule && option.anagrafica.rimosso == false">
					<span class="glyphicon glyphicon-ok-circle green"></span>
				</p>
				<p class="col-xs-1 col-sm-1 matricola" *ngIf="isAmministrazioneModule && option.anagrafica.rimosso == true">
					<span class="glyphicon glyphicon-ban-circle red"></span>
				</p>
				<!--<p *ngIf="(isPartiSearch && option.anagrafica.tipoPersona?.label === PROPERTIES_SETTINGS.LABEL_TIPO_PERSONA_FISICA) || isLegale"
					class="col-sm-3 matricola">
					Codice Cassa : <strong>{{option.anagrafica.codiceMeccanografico}}</strong>
				</p>-->

			</div>
		</div>
		<ul class="collapse subcontroparte" id="subcontroparteModalAdd{{indice}}">
			<li>
				<div class="container_dati_generali">
					<app-dati-generali-anagrafiche-search *ngIf="isPrd" [option]="option"
						[isLegale]="isLegale" [isPartiSearch]="isPartiSearch" [isControparte]="isControparte"></app-dati-generali-anagrafiche-search>
					<div class="row" *ngIf="isAmministrazioneModule">
						<!--<p class="col-sm-3 col-sm-offset-6 col-xs-3 col-xs-offset-9">
							<button type="button" class="btn btn-primary btn-block"
								(click)="generaDoc(option.anagrafica)" [disabled]="option.anagrafica.rimosso">Genera documento</button>
						</p>-->
						<p class="col-sm-3 col-sm-offset-9 col-xs-4">
							<button type="button" class="btn btn-primary btn-block" (click)="associa(option, indice)"
								[disabled]="option.anagrafica.rimosso">Modifica dati</button>
						</p>
					</div>
				</div>
			</li>
		</ul>
	</li>
	<p *ngIf="optionsList.length == 0 && msgEmpty">{{msgEmpty}}</p>

	<div *ngIf="optionsList.length > 0 " class="standardpanel">
		<div class="row">
			<p *ngIf="totali > optionsList.length" class="allinea_centro col-sm-12">
				<a href="javascript:void(0);" (click)="reloadSearch()"> <strong>Carica
						altri risultati</strong></a>
			</p>
			<p *ngIf="totali <= optionsList.length" class="allinea_centro col-sm-12">
				<strong>Risultati totali {{totali}}</strong>
			</p>
			<p *ngIf="totali > optionsList.length" class="allinea_centro col-sm-12">
				<strong>Risultati {{optionsList.length}} di {{totali}}</strong>
			</p>
		</div>
	</div>
</ul>